import type { CapabilitySelectDto, MissionAssessmentCapabilityAiGenerationDataDto } from '@@types/api.types';
import { asStringArray } from '@utils/parse.util';

type CapabilitySuggestionItem = {
  description?: string;
  id: string;
  name: string;
};

export const getCapabilitySuggestionItems = (params: {
  capabilities: CapabilitySelectDto[];
  suggestion: MissionAssessmentCapabilityAiGenerationDataDto | null;
}): CapabilitySuggestionItem[] => {
  const { capabilities, suggestion } = params;
  if (!suggestion) return [];

  const capabilityById = new Map(capabilities.map((capability) => [capability.id, capability]));

  return suggestion.capabilities.map((capabilityId) => {
    const capability = capabilityById.get(capabilityId);
    if (capability) {
      return {
        description: capability.description,
        id: capability.id,
        name: capability.name,
      };
    }

    return {
      id: capabilityId,
      name: `Unknown Capability (${capabilityId.slice(0, 8)})`,
    };
  });
};

export const replaceCapabilitiesWithSuggestion = (params: {
  currentCapabilities: string[];
  suggestion: MissionAssessmentCapabilityAiGenerationDataDto;
}): string[] => {
  const { suggestion } = params;

  return suggestion.capabilities;
};

/**
 * Parse a server-resolved chat artifact object into the capability generation
 * shape. Returns undefined when the object does not match.
 */
export const parseGeneratedCapabilityData = (
  value: Record<string, unknown>,
): MissionAssessmentCapabilityAiGenerationDataDto | undefined => {
  const capabilities = asStringArray(value.capabilities);

  if (!capabilities) {
    return undefined;
  }

  return { capabilities };
};
